import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SearchNeumaticosFiltrosMotoStateType {
  marca: string[]
  gama: string[]
  tipo: string[]
  aplicacion: string[]
  normativa: string | null
  precio: {
    min: number | null
    max: number | null
  }
}

export const initialState: SearchNeumaticosFiltrosMotoStateType = {
  marca: [],
  gama: [],
  tipo: [],
  aplicacion: [],
  normativa: null,
  precio: {
    min: null,
    max: null,
  },
}

export const key = 'searchNeumaticosMoto/Filtros'

const filtrosMotoSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    setMarca: (state, action: PayloadAction<string[]>) => {
      state.marca = action.payload
    },
    setGama: (state, action: PayloadAction<string[]>) => {
      state.gama = action.payload
    },
    setTipo: (state, action: PayloadAction<string[]>) => {
      state.tipo = action.payload
    },
    setAplicacion: (state, action: PayloadAction<string[]>) => {
      state.aplicacion = action.payload
    },
    setNormativa: (state, action: PayloadAction<string | null>) => {
      state.normativa = action.payload
    },
    setPrecio: (
      state,
      action: PayloadAction<{ min: number | null; max: number | null }>
    ) => {
      state.precio = action.payload
    },
    resetFiltrosMoto: () => initialState,
  },
})

export const {
  setMarca,
  setGama,
  setTipo,
  setAplicacion,
  setNormativa,
  setPrecio,
  resetFiltrosMoto,
} = filtrosMotoSlice.actions

export default filtrosMotoSlice.reducer
